import { AlertInfo } from './../enums/alert-info';
import { Injectable } from '@angular/core';
import { CommonEnum } from '../enums/common';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  showStickyMessage(err: any, arg1: null, error: any) {
    throw new Error('Method not implemented.');
  }
  constructor() { }
  showMessage(icon: string, title: string) {
    const Toast = Swal.mixin({
      toast: true,
      position: 'bottom',
      showConfirmButton: false,
      timer: 6000,
      timerProgressBar: true,
      // onOpen: (toast) => {
      //   toast.addEventListener('mouseenter', Swal.stopTimer);
      //   toast.addEventListener('mouseleave', Swal.resumeTimer);
      // },
    });

    Toast.fire({
      icon: icon as SweetAlertIcon,
      title: title,
    });
  }
  closePopup(message: any, callback: any) {

    Swal.fire({
      icon: 'warning',
      title: 'Are you sure?',
      text: message,

      showCancelButton: true,
      confirmButtonColor: CommonEnum.CONFIRM_BUTTON_COLOR,
      cancelButtonColor: CommonEnum.CANCEL_BUTTON_COLOR,
      confirmButtonText: CommonEnum.YES,
    }).then((result) => {
      if (result.isConfirmed) {
        callback(result.isConfirmed);
      }
    })

  }
  DeleteConfirmation(callback: any) {
    Swal.fire({
      title: CommonEnum.CONFIRM,
      text: CommonEnum.FILEREMOVE,
      icon: AlertInfo.WARNING,
      showCancelButton: true,
      confirmButtonColor: CommonEnum.CONFIRM_BUTTON_COLOR,
      cancelButtonColor: CommonEnum.CANCEL_BUTTON_COLOR,
      confirmButtonText: CommonEnum.YES_DELETE,
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {

        callback(result.isConfirmed);
        // Swal.fire(
        //   CommonEnum.DELETED,
        //   CommonEnum.DELETED_SUCCESS,
        //   AlertInfo.SUCCESS
        // )
      }
    })
  }


  DeleteAnswerConfirmation(callback: any) {
    Swal.fire({
      title: CommonEnum.CONFIRM,
      text: CommonEnum.REMOVEANSWER,
      icon: AlertInfo.WARNING,
      showCancelButton: true,
      confirmButtonColor: CommonEnum.CONFIRM_BUTTON_COLOR,
      cancelButtonColor: CommonEnum.CANCEL_BUTTON_COLOR,
      confirmButtonText: CommonEnum.YES_DELETE,
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {

        callback(result.isConfirmed);
        // Swal.fire(
        //   CommonEnum.DELETED,
        //   CommonEnum.DELETED_SUCCESS,
        //   AlertInfo.SUCCESS
        // )
      }
    })
  }


  unfavouriteConfirmation(callback: any) {
    Swal.fire({
      title: CommonEnum.CONFIRM,
      text: CommonEnum.UNFAVTUTOR,
      icon: AlertInfo.WARNING,
      showCancelButton: true,
      confirmButtonColor: CommonEnum.CONFIRM_BUTTON_COLOR,
      cancelButtonColor: CommonEnum.CANCEL_BUTTON_COLOR,
      confirmButtonText: CommonEnum.YES_UNFAVOURITE,
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {

        callback(result.isConfirmed);
        // Swal.fire(
        //   CommonEnum.DELETED,
        //   CommonEnum.DELETED_SUCCESS,
        //   AlertInfo.SUCCESS
        // )
      }
    })
  }

  DeletecertificateIssue(callback: any) {
    Swal.fire({
      title: CommonEnum.CONFIRM,
      text: CommonEnum.CertificateIssue,
      icon: AlertInfo.WARNING,
      showCancelButton: true,
      confirmButtonColor: CommonEnum.CONFIRM_BUTTON_COLOR,
      cancelButtonColor: CommonEnum.CANCEL_BUTTON_COLOR,
      confirmButtonText: CommonEnum.YES_SWITCHON,
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {

        callback(result.isConfirmed);
        // Swal.fire(
        //   CommonEnum.DELETED,
        //   CommonEnum.DELETED_SUCCESS,
        //   AlertInfo.SUCCESS
        // )
      }
    })
  }

  DeleteServicesFromProposal(callback: any, text: string) {
    Swal.fire({
      title: CommonEnum.CONFIRM,
      text: text,
      icon: AlertInfo.WARNING,
      showCancelButton: true,
      confirmButtonColor: CommonEnum.CONFIRM_BUTTON_COLOR,
      cancelButtonColor: CommonEnum.CANCEL_BUTTON_COLOR,
      confirmButtonText: CommonEnum.YES_DELETE,
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        callback(result.isConfirmed);
        // Swal.fire(
        //   CommonEnum.DELETED,
        //   CommonEnum.DELETED_SUCCESS,
        //   AlertInfo.SUCCESS
        // )
      }
    })
  }

  DeletePaymentMethod(callback: any) {
    Swal.fire({
      title: CommonEnum.CONFIRM,
      text: CommonEnum.DELETE_CARD_CONFIRM,
      icon: AlertInfo.WARNING,
      showCancelButton: true,
      confirmButtonColor: CommonEnum.CONFIRM_BUTTON_COLOR,
      cancelButtonColor: CommonEnum.CANCEL_BUTTON_COLOR,
      confirmButtonText: 'Yes',
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        callback(result.isConfirmed);
        // Swal.fire(
        //   CommonEnum.DELETED,
        //   CommonEnum.DELETED_SUCCESS,
        //   AlertInfo.SUCCESS
        // )
      }
    })
  }

  LogoutOrRefreshTokenConfirm(callback: any) {
    Swal.fire({
      title: CommonEnum.CONFIRM,
      text: CommonEnum.SESSION_OR_LOGOUT_CONFIRM,
      icon: AlertInfo.WARNING,
      showCancelButton: true,
      confirmButtonColor: CommonEnum.CONFIRM_BUTTON_COLOR,
      cancelButtonColor: CommonEnum.CANCEL_BUTTON_COLOR,
      confirmButtonText: 'Continue session',
      cancelButtonText: 'Logout',
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        callback(result.isConfirmed);
        // Swal.fire(
        //   CommonEnum.DELETED,
        //   CommonEnum.DELETED_SUCCESS,
        //   AlertInfo.SUCCESS
        // )
      }
      else{
        callback(false);
      }
    })
  }

  TimerStopConfirmation(callback: any) {
    Swal.fire({
      title: CommonEnum.CONFIRM,
      text: CommonEnum.STOP_TIMER,
      icon: AlertInfo.WARNING,
      showCancelButton: true,
      confirmButtonColor: CommonEnum.CONFIRM_BUTTON_COLOR,
      cancelButtonColor: CommonEnum.CANCEL_BUTTON_COLOR,
      confirmButtonText: CommonEnum.YES_DELETE,
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {

        callback(result.isConfirmed);
        // Swal.fire(
        //   CommonEnum.DELETED,
        //   CommonEnum.DELETED_SUCCESS,
        //   AlertInfo.SUCCESS
        // )
      }
    })
  }
  LogoutConfirmation(callback: any) {
    Swal.fire({
      title: CommonEnum.CONFIRM,
      text: CommonEnum.LOGOUT,
      icon: AlertInfo.WARNING,
      showCancelButton: true,
      confirmButtonColor: CommonEnum.CONFIRM_BUTTON_COLOR,
      cancelButtonColor: CommonEnum.CANCEL_BUTTON_COLOR,
      confirmButtonText: CommonEnum.YES_LOGOUT_PORTAL,
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {

        callback(result.isConfirmed);
        // Swal.fire(
        //   CommonEnum.DELETED,
        //   CommonEnum.DELETED_SUCCESS,
        //   AlertInfo.SUCCESS
        // )
      }
    })
  }

  requiredConfirmation(titleHeader: string, message: string, showCancelButton = true, callback: any) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-sm btn-primary ml-10',
        cancelButton: 'btn btn-sm btn-danger mr-10'
      },
      buttonsStyling: false
    })

    swalWithBootstrapButtons.fire({
      title: titleHeader,
      text: message,
      icon: AlertInfo.WARNING,
      showCancelButton: showCancelButton,
      confirmButtonText: CommonEnum.YES,
      cancelButtonText: CommonEnum.CONFIRM_LATER,
      reverseButtons: true,
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        callback(result.isConfirmed);
      } else {
        callback(false);
      }
      // else if (
      //   /* Read more about handling dismissals below */
      //   result.dismiss === Swal.DismissReason.cancel
      // ) {
      //   swalWithBootstrapButtons.fire(
      //     'Cancelled',
      //     'Your imaginary file is safe :)',
      //     'error'
      //   )
      // }
    })
  }
    unfavouriteToolsConfirmation(callback: any) {
    Swal.fire({
      title: CommonEnum.CONFIRM,
      text: CommonEnum.UNFAVTUTORTOOLS,
      icon: AlertInfo.WARNING,
      showCancelButton: true,
      confirmButtonColor: CommonEnum.CONFIRM_BUTTON_COLOR,
      cancelButtonColor: CommonEnum.CANCEL_BUTTON_COLOR,
      confirmButtonText: CommonEnum.YES_UNFAVOURITE,
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {

        callback(result.isConfirmed);
        // Swal.fire(
        //   CommonEnum.DELETED,
        //   CommonEnum.DELETED_SUCCESS,
        //   AlertInfo.SUCCESS
        // )
      }
    })
  }
}
